import { IconButton } from '@neo4j-ndl/react';
import { FunnelIconOutline } from '@neo4j-ndl/react/icons';

export const FilterIconButton = ({
  handleClick,
  hasActiveFilters,
}: {
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hasActiveFilters: boolean;
}) => {
  return (
    <div className="relative">
      {hasActiveFilters && (
        <div className="absolute left-[-4px] top-[-4px]">
          <svg width={12} height={12}>
            <circle cx="6" cy="6" r="6" className="fill-palette-neutral-text-inverse" />
            <circle cx="6" cy="6" r="4" className="fill-palette-primary-icon" />
          </svg>
        </div>
      )}
      <IconButton ariaLabel="Filter deployments" size="medium" onClick={handleClick}>
        <FunnelIconOutline />
      </IconButton>
    </div>
  );
};
